import __request__ from "routing/request";
export function put(allowlist, requestOptions) {
  return __request__("PUT", "/system/urlallowlist", allowlist, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(requestOptions) {
  return __request__("GET", "/system/urlallowlist", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function check(JSONbody, requestOptions) {
  return __request__("POST", "/system/urlallowlist/check", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function generateRegex(JSONbody, requestOptions) {
  return __request__("POST", "/system/urlallowlist/generate_regex", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
